<template>
  <b-container>
    <Headline title="Recent Plays">
      <b-button class="btn-secondary" @click="clearHistory">
        <font-awesome-icon icon="times" /> &nbsp; clear history
      </b-button>
    </Headline>

    <div v-if="playlist">
      <b-row v-for="video in playlist.videos" :key="video.id" align-v="center">
        <b-col cols="8" class="info">
          <LinkButton @click="removeVideo(video)" class="remove">
            <font-awesome-icon icon="times"/>
          </LinkButton>
          <VideoCard :video="video" :showDate="true" :showArtist="true" class="horizontal collapse" :related="playlist.videos" />
        </b-col>
        <b-col cols="4" class="text-right actions">
          <LinkButton @click="removeVideo(video)" class="remove">
            <font-awesome-icon icon="times"/>
          </LinkButton>
          <font-awesome-icon icon="plus" :id="'historyAddToPlaylist' + video.id" class="add-button" />
          <AddToPlaylist :target="'historyAddToPlaylist' + video.id" :video="video" />
          <Pay :video="video"></Pay>
        </b-col>
      </b-row>
    </div>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    margin-top: 1em;
  }

  .info {
    display: flex;
    align-items: center;
    @include media-breakpoint-down(sm) {
      width: 100%;
      max-width: 100%;
      flex: 0 0 100%;
      .remove {
        display: none;
      }
    }

    .remove {
      margin-right: 0.5em;
    }

    .horizontal {
      flex: 1;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
    .remove {
      display: none;
    }
    @include media-breakpoint-down(md) {
      flex-direction: column;
      justify-content: center;
      svg {
        margin-bottom: 12px;
        margin-left: 21px;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    .actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      flex: 0 0 100%;
      max-width: 100%;
      margin-bottom: 1em;
      padding-bottom: 1.2em;
      border-bottom: 1px solid rgba(0,0,0,.3);
      svg {
        margin-bottom: 0px;
        margin-right: 10px;
      }
      .remove {
        display: block;
      }
    }
  }

  .add-button:hover {
    color: $aqua-marine;
  }

  .col-0 {
    flex-grow: 0;
  }
</style>

<script>
import { mapGetters } from 'vuex'
import filter from 'lodash/filter'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import VideoCard from '@/components/widgets/VideoCard'
import AddToPlaylist from '@/components/widgets/AddToPlaylist'
import Pay from '@/components/widgets/Pay'
import Headline from '@/components/widgets/Headline'
import LinkButton from '@/components/widgets/LinkButton'

export default {
  name: 'History',
  components: {
    FontAwesomeIcon,
    VideoCard,
    AddToPlaylist,
    Pay,
    Headline,
    LinkButton
  },
  computed: {
    history () {
      return this.currentUser.default_playlists.history
    },
    ...mapGetters('profile', ['currentUser'])
  },
  data () {
    return {
      playlist: null,
      purchasedSongs: null
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      const request = this.$store.dispatch('playlist/getPlaylist', {id: this.history.id})
      this.playlist = await request
    },
    async clearHistory () {
      await this.$store.dispatch('playlist/updatePlaylist', {id: this.history.id, video_ids: []})
      this.playlist.videos = []
      this.history.video_ids = []
    },
    async removeVideo (video) {
      await this.$store.dispatch('playlist/removePlaylistSong', {playlistId: this.history.id, songId: video.id})
      this.playlist.videos = filter(this.playlist.videos, v => v.id !== video.id)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/fan/History.vue